import type { ReactNode } from 'react'
import { usePermissions } from '@/shared/hooks/usePermissions'
import { SettingsPermissionDenied } from '@/features/settings/settings-permission-denied'

type SettingsAccessGateProps = {
  children: ReactNode
}

export function SettingsAccessGate({ children }: SettingsAccessGateProps) {
  const { checkPermission } = usePermissions()
  const canManageOrganization = checkPermission('organization', 'update')

  if (!canManageOrganization) {
    return <SettingsPermissionDenied />
  }

  return <>{children}</>
}
